import { H4, P2, MainButton } from '@moneymade/moneymade-ui'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'

import { ROUTES } from 'static/menusConstants'
import { getCdnImg } from 'utils/getters'
import ImgLazy from 'components/ui/ImgLazy/ImgLazy'
import styles from './Platform.module.scss'

const Platform = ({ webpart: { text, slugBackgroundColor, slug, logo, name, averageRating, industry } }) => {
  const { push } = useRouter()

  return (
    <div className={styles.Platform} style={{ background: slugBackgroundColor }}>
      <div className={styles.Container}>
        <div className={styles.Left}>
          {logo && <ImgLazy width={64} height={64} src={getCdnImg(logo, 64)} alt={text} />}

          <div className={styles.RatingBlock}>
            {name && (
              <H4 weight="bold" type="heading" className={styles.Title}>
                {name}
              </H4>
            )}
            <div className={styles.Rating}>
              {!!averageRating && (
                <>
                  <i className={`icon-star-filled `} />
                  <P2 weight="light" className={styles.Value}>
                    {averageRating.toFixed(1)}
                  </P2>
                  {!!averageRating && industry && <P2 className={styles.Dot}>•</P2>}
                </>
              )}
              {industry && <P2 className={styles.Industry}>{industry}</P2>}
            </div>
          </div>
        </div>
        <div className={styles.Right}>
          {slug && (
            <MainButton
              fontType="heading"
              size="sm"
              color="dark"
              onClick={() => push(`/${ROUTES.discover}/${slug}`)}
              className={styles.Button}
            >
              Details
            </MainButton>
          )}
        </div>
      </div>
    </div>
  )
}

Platform.propTypes = {
  webpart: PropTypes.shape({
    text: PropTypes.string,
    description: PropTypes.string,
    backgroundColor: PropTypes.string,
    slugBackgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    image: PropTypes.string,
    slug: PropTypes.string,
    titleRTE: PropTypes.string,
    imageOnLeftSize: PropTypes.bool,
    logo: PropTypes.string,
    name: PropTypes.string,
    averageRating: PropTypes.number,
    industry: PropTypes.string
  })
}

Platform.defaultProps = {
  webpart: {
    text: '',
    description: '',
    backgroundColor: '#EE3626',
    slugBackgroundColor: '#f2f2f4',
    textColor: '#FFFFFF',
    image: '',
    slug: '',
    titleRTE: '',
    imageOnLeftSize: true,
    logo: '',
    name: '',
    averageRating: 0,
    industry: ''
  }
}

export default Platform
